import { ActionContext, ActionTree } from "vuex";
import { ISectionState } from "@/store/modules/section/types";
import { RootState } from "@/store/types";
import { ApiCaller } from "@/ApiCaller";

type SectionActionContext = ActionContext<ISectionState, RootState>;
type SectionActionTree = ActionTree<ISectionState, RootState>;

export const actions: SectionActionTree = {
  async fetchSections(context: SectionActionContext): Promise<any> {
    const sections = await ApiCaller.getInstance().get("homeroom/sections");
    context.commit("setSections", sections.data);
  },
};
